/*
 * @Author       : gaoxiyu
 * @Date         : 2022-07-03 14:49:15
 * @LastEditTime : 2022-07-12 11:01:21
 * @LastEditors  : gaoxiyu
 */
const SOJ = {
  site: 'jikejia',
  nUid: 'ajk_member_id',
  nGuid: 'ajk_member_id',
  nCtid: 'ctid'
}

window.loggerLoad = window.soj && new window.soj.Logger({
  customUrl: '//s.anjuke.com/stb?__site=anjuke&',
  site: SOJ.site,
  type: '1', // 浏览日志
  plat: '1', // PC
  page: 'default_soj_pagename',
  nUid: SOJ.nUid,
  nGuid: SOJ.nGuid,
  nCtid: SOJ.nCtid,
  ep: { broker_id: window.soj.fun.getCookie(SOJ.nUid) }
})

// Action级
window.loggerAction = window.soj && new window.soj.Logger({
  customUrl: '//s.anjuke.com/stb?__site=anjuke&',
  site: SOJ.site,
  type: '2', //
  plat: '1', // PC
  page: 'default_soj_pagename',
  nUid: SOJ.nUid,
  nGuid: SOJ.nGuid,
  nCtid: SOJ.nCtid,
  ep: { broker_id: window.soj.fun.getCookie(SOJ.nUid) }
})

export default {}
